import { func } from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import BetTips from 'calendar/components/BetTips';
import { fetchAtgBetTips, fetchSportBetTips } from 'calendar/redux/actions';
import { betTips } from 'calendar/redux/selectors';
import { showConfirmDialog } from 'shared/redux/actions';
import { ui } from 'shared/redux/selectors';
import { getText } from 'shared/utils/Text';

const mapStateTopProps = state => ({
  betTips: betTips.getBetTips(state),
  error: betTips.getTipsError(state),
  isLoading: betTips.isTipsLoading(state),
  isPageVisible: ui.isPageVisible(state),
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      fetchAtgBetTips,
      fetchSportBetTips,
      showConfirmDialog,
    },
    dispatch,
  );

export default connect(
  mapStateTopProps,
  mapDispatchToProps,
)(
  class BetTipsContainer extends Component {
    static propTypes = {
      onCreateAtgBet: func.isRequired,
      onCreateSportBet: func.isRequired,
    };

    state = {
      shouldFetchOnNextPageVisibilty: false,
    };

    componentDidMount() {
      this.props.fetchAtgBetTips();
      this.props.fetchSportBetTips();
    }

    componentDidUpdate(prevProps) {
      if (
        !prevProps.isPageVisible &&
        this.props.isPageVisible &&
        this.state.shouldFetchOnNextPageVisibilty
      ) {
        this.setState({
          shouldFetchOnNextPageVisibilty: false,
        });
        this.props.fetchAtgBetTips();
        this.props.fetchSportBetTips();
      }
    }

    onUseClick = (provider, tipBetId) => {
      if (provider === 'Överodds' || provider === 'JokerSport') {
        this.props.onCreateSportBet({ tipBetId });
      } else {
        this.props.onCreateAtgBet({ tipBetId });
      }
    };

    onBuyClick = (title, details, url) => {
      this.props.showConfirmDialog({
        title,
        details,
        url,
        onConfirm: () => {
          this.setState({
            shouldFetchOnNextPageVisibilty: true,
          });
        },
        positive: getText('dialog-confirm-confirm'),
        negative: getText('dialog-confirm-cancel'),
      });
    };

    render() {
      const { betTips, error, isLoading } = this.props;

      return (
        <BetTips
          tips={betTips}
          error={error}
          isLoading={isLoading || (betTips.length === 0 && error == null)}
          onUseClick={this.onUseClick}
          onBuyClick={this.onBuyClick}
        />
      );
    }
  },
);
